import type { ApiResponse , Client } from "../types/api.types";

import { collectCrmClientActivesMatchIds } from "./crmClientActivesUserId";
import { buildFetchItemsQuery } from "./legacy";

/** Архивные клиенты менеджера — те же id, что для фильтра активов. */
export function fetchCrmArchivedClientIdsForManager(managerId: string | number): Promise<Set<number>> {
    return new Promise((resolve, reject) => {
        buildFetchItemsQuery(null, true, null, false)
            .where("manager_id", managerId)
            .all(
                (response: ApiResponse<any>) => {
                    const rows = (Array.isArray(response?.data) ? response.data : []) as Client[];
                    const ids = new Set<number>();
                    for (const c of rows) {
                        for (const id of collectCrmClientActivesMatchIds(c)) {
                            ids.add(id);
                        }
                    }
                    resolve(ids);
                },
                (err: any) => reject(err)
            );
    });
}
